var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-file-input',{ref:"fileInput",attrs:{"value":_vm.wrappedItem,"label":_vm.label,"dense":"","success":_vm.success,"loading":_vm.uploading},on:{"change":_vm.onFileChange},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var text = ref.text;
return [_vm._v(" "+_vm._s(text)+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }